<div *ngIf="templateNo==1">
<app-toast [toastModel]="toastModel" *ngIf="isToastShow"></app-toast>
<app-progress-bar [isLoading]="isLoading"></app-progress-bar>
<div class="row mx-1 mt-1">
  <div class="col-12">
    <span class="cursor-pointer text-primary ml-2 cursor-pointer pull-right" *ngIf="filterType === 'self'"
      (click)="updateSelfAssessment()"><i class="fa fa-floppy-o text-dark"></i>
      Save</span>
    <a href="/self-assessment/details/self/{{selfAssessment.id}}" *ngIf="filterType === 'version'"
      class="cursor-pointer text-primary cursor-pointer pull-right ml-2"><i class="fa fa-undo text-dark"></i>
      Current Version</a>
    <span class="cursor-pointer text-primary cursor-pointer pull-right ml-2" (click)="openDialog()"><i
        class="fa fa-history text-dark"></i> Version History</span>
    <span class="cursor-pointer text-primary cursor-pointer pull-right ml-2">
      <i class="fa fa-square-o icon-font vertical-align-middle" (click)="selfAssessment.isSendNotification = true"
        *ngIf="!selfAssessment.isSendNotification" aria-hidden="true"></i>
      <i class="fa fa-check-square icon-font vertical-align-middle" (click)="selfAssessment.isSendNotification = false"
        *ngIf="selfAssessment.isSendNotification" aria-hidden="true"></i>
      Send Notification 
    </span>
    <span class="mb-2 text-muted" *ngIf="checkSibling(selfAssessmentId, 'Next')">
      <span class="text-blue float-right ml-4" (click)="getSiblings('Next')">Next</span>
    </span>
    <span class="mb-2 text-muted" *ngIf="checkSibling(selfAssessmentId, 'Previous')">
      <span class="text-blue float-right" (click)="getSiblings('Previous')">Previous</span>
    </span>
    
    <!-- <div [ngClass]="filterType === 'version' ? 'card-highlight' : ''">
      <button class="btn bg-g-lightGreen btn-sm pull-right" (click)="updateSelfAssessment()">
        <i class="fa fa-floppy-o"></i> Save <i *ngIf="isSaved" class="fa fa-circle-o-notch fa-spin"
          style="font-size: .875rem; line-height: 1.5;"></i></button>
    </div> -->
  </div>
</div>
<div class="row mt-1 mb-1 mx-1">
  <div class="col-12 accordions">
    <mat-accordion id="SummaryDetails" class="mt-1">
      <mat-expansion-panel [expanded]="true" class="ia-expansion-panel pl-2">
        <mat-expansion-panel-header class="ia-mat-panel">
          <mat-panel-title>
            <span class="text-header inc-f">
              Summary Details
            </span>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div id="SummaryDetails">
          <div class="row ml-2 mt-4">
            <div class="col-lg-2">
              <label class="control-label fw">Change ID</label>
              <div class="pt-1 d-flex flex-wrap gap-1" *ngIf="selfAssessment.rulebookRuleID">
                <a class="mb-0 redirect_tag" *ngFor="let rId of selfAssessment.rulebookRuleID.split('|')" (click)="openView(rId, 2)" target="_blank">{{ rId }}</a>
              </div>
            </div>
            <!-- <div class="col-lg-4 text-center">
              <div class="left inline label-heading control-label mb-1 fw">Part</div>
              <div class="input-group">
                {{selfAssessment.part}}
              </div>
            </div> -->
            <div class="col-md-8 col-lg-8">
              <div class="form-group">
                <div class="left inline label-heading control-label mb-1 fw">Part</div>
                <div class="input-group self_part pt-1">
                  <p class="mb-0" *ngFor="let rPart of selfAssessment.part.split(',')">{{rPart}}</p>
                </div>
              </div>
            </div>
            <div class="col-lg-2">
              <label class="control-label fw">Regulator</label>
              <div class="pt-1" *ngIf="selfAssessment.regulator">
                <p class="mb-0" *ngFor="let item of selfAssessment.regulator.split('|')">{{item}}</p>
              </div>
            </div>
            <div class="col-lg-12">
              <label class="control-label fw">Owner</label>
              <div class="applies_accross_row mt-1">
                <!-- <mat-chip-grid #ownerList class="cdk-overlay-pane owner_chiplist" matChipInputFor="ownerInput">
                  <mat-chip-row *ngFor="let owner of ownerDD" [selectable]="false" [removable]="false"
                    (removed)="removeOwner(owner)">
                    {{owner}}
                    <mat-icon matChipRemove disabled class="clear-icons">clear
                    </mat-icon>
                  </mat-chip-row>
                  <input class="form-control form-control-sm mat-autodd-input border-bottom w-100"
                    #trigautoOwner="matAutocompleteTrigger" [attr.disabled]="true" #ownerInput
                    [formControl]="searchOwnerCntrl" [matAutocomplete]="ownerAutocomplete" [matChipInputFor]="ownerList"
                    [matChipInputSeparatorKeyCodes]="separatorKeysCodes" [matChipInputAddOnBlur]="addOnBlur"
                    autocomplete="off" (matChipInputTokenEnd)="addOwner($event)">
                </mat-chip-grid>
                <mat-autocomplete #ownerAutocomplete="matAutocomplete" (optionSelected)="selectedOwnerEvent($event)">
                  <mat-option *ngFor="let owner of searchedOwner" [value]="owner">
                    {{owner.name}}
                  </mat-option>
                </mat-autocomplete> -->
                <!-- <div class="tags_part" *ngIf="ownerDD && ownerDD.length>0">
                  <div class="mb-2" *ngFor="let namesString of ownerDD">
                    <span class="tag" *ngFor="let name of namesString.split(',')">{{ name }}
                    </span>
                  </div>
                </div> -->
                <div *ngIf="ownerDD && ownerDD.length>0">
                  <div class="tags_part mb-3" *ngFor="let namesString of ownerDD">
                    <div>
                      <span class="tag mr-1" *ngFor="let name of namesString.split(',')">{{ name }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </mat-expansion-panel>
    </mat-accordion>
    <mat-accordion id="AdditionalDetails">
      <mat-expansion-panel [expanded]="false" class="ia-expansion-panel pl-2">
        <mat-expansion-panel-header class="ia-mat-panel">
          <mat-panel-title>
            <span class="text-header inc-f">
              Additional Details
            </span>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="row ml-2 mt-1">
          <div class="col-lg-4">
            <label class="control-label fw">Date</label>
            <div class="pt-2 control-label">{{effectiveDate | date: 'dd-MMM-yyyy'}}</div>
          </div>
          <div class="col-lg-4">
            <label class="control-label fw">Rulebook</label>
            <div class="pt-2" *ngIf="selfAssessment.ruleBook">
              <p class="mb-0" *ngFor="let item of selfAssessment.ruleBook.split('|')">{{item}}</p>
            </div>
          </div>
          <div class="col-lg-4">
            <label class="control-label fw">Rule ID</label>
            <div class="pt-2" *ngIf="selfAssessment.ruleID">
              <p class="mb-0" *ngFor="let item of selfAssessment.ruleID.split('|')">{{item}}</p>
            </div>
          </div>
        </div>

        <div class="row ml-2 mt-1">
          <div class="col-lg-10 fw">
            <label class="control-label fw">Description</label>
            <div class="edit_status_changeViewer_group">
              <!-- <mat-form-field class="disableText w-100">
                <textarea *ngFor="let item of selfAssessment.regulatoryRuleFullRequirement.split('|')" matInput
                  cdkTextareaAutosize disabled class="text-area-css textarea_input">
                   {{item}}
                  </textarea>
              </mat-form-field> -->
              <div *ngFor="let item of selfAssessment.regulatoryRuleFullRequirement.split('|')">
                <div *ngIf="item | hasHtmlTags; else noHtmlTags" [innerHTML]="item"></div>
                <ng-template #noHtmlTags>
                  <mat-form-field class="disableText w-100">
                    <textarea matInput cdkTextareaAutosize disabled
                      class="text-area-css textarea_input">{{item}}</textarea>
                  </mat-form-field>
                </ng-template>
              </div>
            </div>
          </div>
          <div class="col-lg-2" *ngIf="selfAssessment.hyperlink">
            <a href="{{selfAssessment.hyperlink}}" target="_blank">
              <i class="fa fa-globe"></i>
              <span class="text-primary cursor-pointer">
                Source Link</span>
            </a>
          </div>
          <div class="col-lg-2" *ngIf="!selfAssessment.hyperlink">
            <i class="fa fa-globe"></i><span> Source Link</span>
          </div>
          <!-- <div class="col-lg-12 mt-1 edit_status_changeViewer_group">
            <mat-form-field class="disableText w-100">
              <textarea matInput [(ngModel)]="formattedDesc" class="text-area-css" cdkTextareaAutosize
                disabled></textarea>
            </mat-form-field>
          </div> -->
        </div>
      </mat-expansion-panel>
    </mat-accordion>
    <mat-accordion id="AssessmentDetails">
      <mat-expansion-panel [expanded]="true" class="ia-expansion-panel pl-2">
        <mat-expansion-panel-header class="ia-mat-panel">
          <mat-panel-title>
            <span class="text-header inc-f">
              Assessment Details
            </span>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div *ngIf="checkRoutePermission('Assessment Detail')">
          <!-- <div class="row">
            <div class="col-lg-12 text-header inc-f">
              <i class="fa fa-list"></i> Assessment Details
            </div>
          </div> -->

          <div class="row ml-2 mt-1">
            <div class="col-lg-3">
              <label class="control-label fw">Assessment Creation Date</label>
              <div class="input-group input-group-sm">
                <input matInput [matDatepicker]="assessmentCreationDate" (click)="assessmentLastEdited.open()" disabled
                  class="form-control form-control-sm border-bottom" [(ngModel)]="selfAssessment.createdDateTime"
                  name="AssessmentCreationDate" (dateInput)="updateSectionLastEdited('Assessment')" />
                <div class="input-group-append">
                  <span class="input-group-text fa fa-calendar" disabled (click)="assessmentLastEdited.open()"></span>
                </div>
              </div>
              <mat-datepicker #assessmentCreationDate></mat-datepicker>
            </div>
            <div class="col-lg-2">
              <label class="control-label fw">Rule Applicable</label>
              <input type="text" placeholder="Pick one" aria-label="Number" name="rule applicable" matInput
                [matAutocomplete]="autoRA" style="margin-top:0px" class="form-control form-control-sm border-bottom"
                [(ngModel)]="selfAssessment.ruleApplicable">
              <mat-autocomplete autoActiveFirstOption #autoRA="matAutocomplete"
                (optionSelected)="updateSectionLastEdited('Assessment')">
                <mat-option *ngFor="let option of ruleApplicable" [value]="option">
                  {{option}}
                </mat-option>
              </mat-autocomplete>
            </div>
            <div class="col-lg-7 edit_status_changeViewer_group">
              <label class="control-label fw">Assessment Description</label>
              <input type="text" class="form-control form-control-sm" (keyup)="updateSectionLastEdited('Assessment')"
                  [(ngModel)]="selfAssessment.rationaleifNo">
              <!-- <mat-form-field class="textarea_field w-100">
                <textarea matInput [(ngModel)]="selfAssessment.rationaleifNo" class="text-area-css" cdkTextareaAutosize  style="margin-top:0px"
                  (keyup)="updateSectionLastEdited('Assessment')"></textarea>
              </mat-form-field> -->
            </div>
          </div>

          <div class="row ml-2 my-4">
            <div class="col-lg-3">
              <label class="control-label fw">Assessment Team</label>
              <input type="text" class="form-control form-control-sm" (keyup)="updateSectionLastEdited('Assessment')"
                [(ngModel)]="selfAssessment.assessmentTeam">
            </div>
            <div class="col-lg-5">
              <label class="control-label fw">Assessor</label>
              <mat-chip-grid #assessorList>
                <mat-chip-row *ngFor="let assessor of assessorDD" [selectable]="selectable && !isVersioned"
                  [removable]="removable && !isVersioned" (removed)="removeAssessor(assessor)">
                  {{assessor}}
                  <mat-icon matChipRemove *ngIf="removable && !isVersioned">x</mat-icon>
                </mat-chip-row>
                <input class="form-control form-control-sm mat-autodd-input h-33 border-bottom" #assessorInput
                  [formControl]="searchAssessorCntrl" [matAutocomplete]="assessorAutocomplete"
                  [matChipInputFor]="assessorList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                  [matChipInputAddOnBlur]="addOnBlur" autocomplete="off" (matChipInputTokenEnd)="addAssessor($event)">
              </mat-chip-grid>
              <mat-autocomplete #assessorAutocomplete="matAutocomplete"
                (optionSelected)="selectedAssessorEvent($event)">
                <mat-option *ngFor="let assessor of searchedAssessor" [value]="assessor.value">
                  {{assessor.name}}
                </mat-option>
              </mat-autocomplete>
            </div>
            <div class="col-lg-4">
              <label class="control-label fw">Assessor Delegate</label>
              <mat-chip-grid #assessorDelList>
                <mat-chip-row *ngFor="let assessor of assessorDelDD" [selectable]="selectable"
                  [removable]="removable && !isVersioned" (removed)="removeAssessorDelegate(assessor)">
                  {{assessor}}
                  <mat-icon matChipRemove *ngIf="removable && !isVersioned">x</mat-icon>
                </mat-chip-row>
                <input class="form-control form-control-sm mat-autodd-input h-33 border-bottom" #assessorDelInput
                  [formControl]="searchAssessorDelCntrl" [matAutocomplete]="assessorDelAutocomplete"
                  [matChipInputFor]="assessorDelList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                  [matChipInputAddOnBlur]="addOnBlur" autocomplete="off"
                  (matChipInputTokenEnd)="addAssessorDelegate($event)">
              </mat-chip-grid>
              <mat-autocomplete #assessorDelAutocomplete="matAutocomplete"
                (optionSelected)="selectedAssessorDelegateEvent($event)">
                <mat-option *ngFor="let assessor of searchedAssessorDel" [value]="assessor.value">
                  {{assessor.name}}
                </mat-option>
              </mat-autocomplete>
            </div>
          </div>

          <div class="row ml-2 mt-1">
            <div class="col-lg-12">
              <div class="box-shadow p-2">
                <div class="header-text">
                  <span class="fa fa-chevron-down cursor-pointer" *ngIf="filterType === 'self' && !isSADetails1"
                    (click)="isSADetails1 = true"></span>
                  <span class="fa fa-chevron-up cursor-pointer" *ngIf="filterType === 'self' && isSADetails1"
                    (click)="isSADetails1 = false"></span>
                  <span class="control-label fw">
                    Assessment Details <span *ngIf="filterType !== 'self' && changeFields.includes('AssessmentDetails')"
                      class="marking-changed-fields">Version {{versionNo}} </span>
                  </span>
                </div>
                <div *ngIf="filterType === 'self' && saDetailHistory && saDetailHistory.assessmentDetails.length > 0">
                  <div *ngFor="let detailItem of saDetailHistory.assessmentDetails">
                    <div class="pt-3" *ngIf="detailItem.itemTitle">
                      <div class="f-16 ck-content" [innerHTML]="sanitizeHtml(detailItem.itemTitle)"></div>
                    </div>
                  </div>
                </div>
                <div *ngIf="filterType === 'version'">
                  <div class="f-16 mt-1 ck-content" [innerHTML]="sanitizeHtml(selfAssessment.assessmentDetails)"></div>
                </div>
                <div class="text-area-css overflow-auto disabled-div ck-content"
                  *ngIf="filterType === 'self' && saDetailHistory && saDetailHistory.assessmentDetails.length === 0"
                  [innerHTML]="sanitizeHtml(selfAssessment.assessmentDetails)"></div>
                  <app-ck-editor [(childVariable)]="selfAssessment.assessmentDetails" [data]="selfAssessment.assessmentDetails" id="assessmentDetails" *ngIf="filterType === 'self' && isSADetails1" (keyUpEvent)="updateSectionLastEdited('Assessment')"></app-ck-editor>
                <!-- <ckeditor id="assessmentDetails" [editor]="Editor" *ngIf="filterType === 'self' && isSADetails1"
                  [(ngModel)]="selfAssessment.assessmentDetails" (keyup)="updateSectionLastEdited('Assessment')">
                </ckeditor> -->
              </div>
            </div>
          </div>

          <div class="row ml-2 pt-3">
            <div class="col-lg-3 cursor-pointer" (click)="uploadEvidenceAssessment()">
              <i class="fa fa-upload"></i>
              <span class="text-primary ml-1 fw">Upload Evidence - Assessment
                <i *ngIf="isAssessmentLoader" class="fa fa-circle-o-notch fa-spin"
                  style="font-size: .875rem; line-height: 1.5;"></i>
              </span>
              <input id="uploadEviAssessment" (change)="handleFileInput($event.target.files)" type="file" multiple
                style="display: none" /><br />
            </div>
            <div class="col-lg-12 mt-3" *ngIf="selfAssessmentDocument.length > 0">
              <ng-container *ngFor="let docs of selfAssessmentDocument">
                <div class="file-div text-center" *ngIf="docs.fileType === 1">
                  <span class="fa fa-trash pull-right delete-docs"
                    (click)="openDeleteModel(docs.id, 'Assessment')"></span>
                  <span class="cursor-pointer"
                    (click)="downloadDocument(docs.id, docs.fileName, docs.fileExtension, 'Assessment')">
                    <i class="fa fa-file-text fa-2x" *ngIf="docs.fileExtension === '.txt'" aria-hidden="true"></i>
                    <i class="fa fa-file-text-o fa-2x"
                      *ngIf="docs.fileExtension === '.eml' || docs.fileExtension === '.msg'" aria-hidden="true"></i>
                    <i class="fa fa-file-pdf-o fa-2x" *ngIf="docs.fileExtension === '.pdf'" aria-hidden="true"></i>
                    <i class="fa fa-file-word-o fa-2x" *ngIf="docs.fileExtension === '.doc'" aria-hidden="true"></i>
                    <i class="fa fa-file-word-o fa-2x" *ngIf="docs.fileExtension === '.docx'" aria-hidden="true"></i>
                    <i class="fa fa-file-excel-o fa-2x" *ngIf="docs.fileExtension === '.xls'" aria-hidden="true"></i>
                    <i class="fa fa-file-excel-o fa-2x" *ngIf="docs.fileExtension === '.xlsx'" aria-hidden="true"></i>
                    <i class="fa fa-file-o fa-2x" *ngIf="docs.fileExtension === '.csv'" aria-hidden="true"></i>
                    <i class="fa fa-file-code-o fa-2x" *ngIf="docs.fileExtension === '.xml'" aria-hidden="true"></i>
                    <i class="fa fa-file-archive-o fa-2x" *ngIf="docs.fileExtension === '.zip'" aria-hidden="true"></i>
                    <i class="fa fa-file-image-o fa-2x" *ngIf="docs.fileExtension === '.jpeg'" aria-hidden="true"></i>
                    <i class="fa fa-file-image-o fa-2x" *ngIf="docs.fileExtension === '.jpg'" aria-hidden="true"></i>
                    <i class="fa fa-file-image-o fa-2x" *ngIf="docs.fileExtension === '.png'" aria-hidden="true"></i>
                    <i class="fa fa-file-powerpoint-o fa-2x"
                      *ngIf="docs.fileExtension === '.ppt' || docs.fileExtension === '.pptx'" aria-hidden="true"></i>
                  </span>
                  <div class="data-div">{{docs.fileName}}</div>
                </div>
              </ng-container>
            </div>
          </div>

          <div class="row ml-2 mt-4">
            <div class="col-lg-4">
              <label class="control-label fw">Assessment Last Edited</label>
              <div class="input-group input-group-sm">
                <input matInput [matDatepicker]="assessmentLastEdited" (click)="assessmentLastEdited.open()" disabled
                  class="form-control form-control-sm border-bottom" [(ngModel)]="selfAssessment.assessmentLastEdited"
                  name="AssessmentLastEdited" (dateInput)="updateSectionLastEdited('Assessment')" />
                <div class="input-group-append">
                  <span class="input-group-text fa fa-calendar" disabled (click)="assessmentLastEdited.open()"></span>
                </div>
              </div>
              <mat-datepicker #assessmentLastEdited></mat-datepicker>
            </div>
            <div class="col-lg-4">
              <label class="control-label fw">Assessment Due Date</label>
              <div class="input-group input-group-sm">
                <input matInput [matDatepicker]="assessmentDueDate" (click)="assessmentDueDate.open()"
                  class="form-control form-control-sm border-bottom" [(ngModel)]="selfAssessment.assessmentDueDate"
                  name="AssessmentDueDate" (dateInput)="updateSectionLastEdited('Assessment')" />
                <div class="input-group-append">
                  <span class="input-group-text fa fa-calendar" (click)="assessmentDueDate.open()"></span>
                </div>
              </div>
              <mat-datepicker #assessmentDueDate (selectedChanged)="updateSectionLastEdited('Assessment')">
              </mat-datepicker>
            </div>
            <div class="col-lg-4">
              <label class="control-label fw">Assessment Status</label>
              <input type="text" placeholder="Pick one" aria-label="Number" name="rule applicable" matInput
                [matAutocomplete]="autoAS" class="form-control form-control-sm border-bottom"
                [(ngModel)]="selfAssessment.assessmentStatus" />
              <mat-autocomplete autoActiveFirstOption #autoAS="matAutocomplete"
                (optionSelected)="updateSectionLastEdited('Assessment')">
                <mat-option *ngFor="let option of assessmentStatus" [value]="option">
                  {{option}}
                </mat-option>
              </mat-autocomplete>
            </div>
          </div>
          <!-- <hr /> -->
        </div>
      </mat-expansion-panel>
    </mat-accordion>
    <mat-accordion id="ReviewDetails">
      <mat-expansion-panel [expanded]="true" class="ia-expansion-panel pl-2">
        <mat-expansion-panel-header class="ia-mat-panel">
          <mat-panel-title>
            <span class="text-header inc-f">
              Review Details
            </span>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div *ngIf="checkRoutePermission('Review Detail')">
          <!-- <div class="row">
            <div class="col-lg-12 text-header inc-f">
              <i class="fa fa-list"></i> Review Details
            </div>
          </div> -->
          <div class="row ml-2 mt-1">
            <div class="col-lg-3">
              <label class="control-label fw">Reviewer Team</label>
              <input type="text" (keyup)="updateSectionLastEdited('Review')" class="form-control form-control-sm"
                [(ngModel)]="selfAssessment.reviewTeam" />
            </div>
            <div class="col-lg-5">
              <label class="control-label fw">Reviewer</label>
              <mat-chip-grid #reviewerList>
                <mat-chip-row *ngFor="let reviewer of reviewerDD" [selectable]="selectable"
                  [removable]="removable && !isVersioned" (removed)="removeReviewer(reviewer)">
                  {{reviewer}}
                  <mat-icon matChipRemove *ngIf="removable && !isVersioned">x</mat-icon>
                </mat-chip-row>
                <input class="form-control form-control-sm h-33 mat-autodd-input border-bottom" #reviewerInput
                  [formControl]="searchReviewerCntrl" [matAutocomplete]="reviewerAutocomplete"
                  [matChipInputFor]="reviewerList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                  [matChipInputAddOnBlur]="addOnBlur" autocomplete="off" (matChipInputTokenEnd)="addReviewer($event)">
              </mat-chip-grid>
              <mat-autocomplete #reviewerAutocomplete="matAutocomplete"
                (optionSelected)="selectedReviewerEvent($event)">
                <mat-option *ngFor="let reviewer of searchedReviewer" [value]="reviewer.value">
                  {{reviewer.name}}
                </mat-option>
              </mat-autocomplete>
            </div>
            <div class="col-lg-4">
              <label class="control-label fw">Reviewer Delegate</label>
              <mat-chip-grid #reviewerDelList>
                <mat-chip-row *ngFor="let reviewer of reviewerDelDD" [selectable]="selectable"
                  [removable]="removable && !isVersioned" (removed)="removeReviewerDelegate(reviewer)">
                  {{reviewer}}
                  <mat-icon matChipRemove *ngIf="removable && !isVersioned">x</mat-icon>
                </mat-chip-row>
                <input class="form-control form-control-sm h-33 mat-autodd-input border-bottom" #reviewerDelInput
                  [formControl]="searchReviewerDelCntrl" [matAutocomplete]="reviewerDelAutocomplete"
                  [matChipInputFor]="reviewerDelList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                  [matChipInputAddOnBlur]="addOnBlur" autocomplete="off"
                  (matChipInputTokenEnd)="addReviewerDelegate($event)">
              </mat-chip-grid>
              <mat-autocomplete #reviewerDelAutocomplete="matAutocomplete"
                (optionSelected)="selectedReviewerDelegateEvent($event)">
                <mat-option *ngFor="let reviewer of searchedReviewerDel" [value]="reviewer.value">
                  {{reviewer.name}}
                </mat-option>
              </mat-autocomplete>
            </div>
          </div>

          <div class="row ml-2 mt-1">
            <div class="col-lg-12">
              <div class="box-shadow p-2">
                <div class="header-text">
                  <span class="fa fa-chevron-down cursor-pointer" *ngIf="filterType === 'self' && !isSADetails2"
                    (click)="isSADetails2 = true"></span>
                  <span class="fa fa-chevron-up cursor-pointer" *ngIf="filterType === 'self' && isSADetails2"
                    (click)="isSADetails2 = false"></span>
                  <span class="control-label fw">
                    Review Details <span *ngIf="filterType !== 'self' && changeFields.includes('ReviewDetails')"
                      class="marking-changed-fields">Version {{versionNo}} </span>
                  </span>
                </div>
                <div *ngIf="filterType === 'self' && saDetailHistory && saDetailHistory.reviewDetails.length > 0">
                  <div *ngFor="let detailItem of saDetailHistory.reviewDetails">
                    <div class="pt-3" *ngIf="detailItem.itemTitle">
                      <div class="f-16 ck-content" [innerHTML]="sanitizeHtml(detailItem.itemTitle)"></div>
                    </div>
                  </div>
                </div>
                <div *ngIf="filterType === 'version'">
                  <div class="f-16 mt-1 ck-content" [innerHTML]="sanitizeHtml(selfAssessment.reviewDetails)"></div>
                </div>
                  <div class="text-area-css overflow-auto disabled-div ck-content"
                    *ngIf="filterType === 'self' && saDetailHistory && saDetailHistory.reviewDetails.length === 0"
                    [innerHTML]="sanitizeHtml(selfAssessment.reviewDetails)"></div>
                    <app-ck-editor [(childVariable)]="selfAssessment.reviewDetails" [data]="selfAssessment.reviewDetails" id="reviewDetails" *ngIf="filterType === 'self' && isSADetails2" (keyUpEvent)="updateSectionLastEdited('Review')"></app-ck-editor>
                <!-- <ckeditor id="reviewDetails" [editor]="Editor" *ngIf="filterType === 'self' && isSADetails2"
                  [(ngModel)]="selfAssessment.reviewDetails" (keyup)="updateSectionLastEdited('Review')"></ckeditor> -->
              </div>
            </div>
          </div>

          <div class="row ml-2 pt-3">
            <div class="col-lg-3 cursor-pointer" (click)="uploadEvidenceReview()">
              <i class="fa fa-upload"></i>
              <span class="text-primary ml-1 fw">Upload Evidence - Review
                <i *ngIf="isReviewLoader" class="fa fa-circle-o-notch fa-spin"
                  style="font-size: .875rem; line-height: 1.5;"></i>
              </span>
              <input id="uploadEviReview" (change)="handleReviewInput($event.target.files)" type="file" multiple
                style="display: none" /><br />
            </div>
            <div class="col-lg-12 mt-3" *ngIf="selfAssessmentDocument.length > 0">
              <ng-container *ngFor="let docs of selfAssessmentDocument">
                <div class="file-div text-center" *ngIf="docs.fileType === 2">
                  <span class="fa fa-trash pull-right delete-docs" (click)="openDeleteModel(docs.id, 'Review')"></span>
                  <span class="cursor-pointer"
                    (click)="downloadDocument(docs.id, docs.fileName, docs.fileExtension, 'Review')">
                    <i class="fa fa-file-text fa-2x" *ngIf="docs.fileExtension === '.txt'" aria-hidden="true"></i>
                    <i class="fa fa-file-text-o fa-2x"
                      *ngIf="docs.fileExtension === '.eml' || docs.fileExtension === '.msg'" aria-hidden="true"></i>
                    <i class="fa fa-file-pdf-o fa-2x" *ngIf="docs.fileExtension === '.pdf'" aria-hidden="true"></i>
                    <i class="fa fa-file-word-o fa-2x" *ngIf="docs.fileExtension === '.doc'" aria-hidden="true"></i>
                    <i class="fa fa-file-word-o fa-2x" *ngIf="docs.fileExtension === '.docx'" aria-hidden="true"></i>
                    <i class="fa fa-file-excel-o fa-2x" *ngIf="docs.fileExtension === '.xls'" aria-hidden="true"></i>
                    <i class="fa fa-file-excel-o fa-2x" *ngIf="docs.fileExtension === '.xlsx'" aria-hidden="true"></i>
                    <i class="fa fa-file-o fa-2x" *ngIf="docs.fileExtension === '.csv'" aria-hidden="true"></i>
                    <i class="fa fa-file-code-o fa-2x" *ngIf="docs.fileExtension === '.xml'" aria-hidden="true"></i>
                    <i class="fa fa-file-archive-o fa-2x" *ngIf="docs.fileExtension === '.zip'" aria-hidden="true"></i>
                    <i class="fa fa-file-image-o fa-2x" *ngIf="docs.fileExtension === '.jpeg'" aria-hidden="true"></i>
                    <i class="fa fa-file-image-o fa-2x" *ngIf="docs.fileExtension === '.jpg'" aria-hidden="true"></i>
                    <i class="fa fa-file-image-o fa-2x" *ngIf="docs.fileExtension === '.png'" aria-hidden="true"></i>
                    <i class="fa fa-file-powerpoint-o fa-2x"
                      *ngIf="docs.fileExtension === '.ppt' || docs.fileExtension === '.pptx'" aria-hidden="true"></i>
                  </span>
                  <div class="data-div">{{docs.fileName}}</div>
                </div>
              </ng-container>
            </div>
          </div>

          <div class="row ml-2 mt-4">
            <div class="col-lg-4">
              <label class="control-label fw">Review Last Edited</label>
              <div class="input-group input-group-sm">
                <input matInput [matDatepicker]="reviewLastEdited" (click)="reviewLastEdited.open()" disabled
                  class="form-control form-control-sm border-bottom" [(ngModel)]="selfAssessment.reviewLastEdited"
                  name="ReviewLastEdited" (dateInput)="updateSectionLastEdited('Review')" />
                <div class="input-group-append">
                  <span class="input-group-text fa fa-calendar" disabled (click)="reviewLastEdited.open()"></span>
                </div>
              </div>
              <mat-datepicker #reviewLastEdited></mat-datepicker>
            </div>
            <div class="col-lg-4">
              <label class="control-label fw">Review Due Date</label>
              <div class="input-group input-group-sm">
                <input matInput [matDatepicker]="reviewDueDate" (click)="reviewDueDate.open()"
                  class="form-control form-control-sm border-bottom" [(ngModel)]="selfAssessment.reviewDueDate"
                  name="ReviewDueDate" (dateInput)="updateSectionLastEdited('Review')" />
                <div class="input-group-append">
                  <span class="input-group-text fa fa-calendar" (click)="reviewDueDate.open()"></span>
                </div>
              </div>
              <mat-datepicker #reviewDueDate (selectedChanged)="updateSectionLastEdited('Review')"></mat-datepicker>
            </div>
            <div class="col-lg-4">
              <label class="control-label fw">Review Status</label>
              <input type="text" placeholder="Pick one" aria-label="Number" name="rule applicable" matInput
                [matAutocomplete]="autoRS" class="form-control form-control-sm border-bottom"
                [(ngModel)]="selfAssessment.reviewStatus" />
              <mat-autocomplete autoActiveFirstOption #autoRS="matAutocomplete"
                (optionSelected)="updateSectionLastEdited('Review')">
                <mat-option *ngFor="let option of reviewStatus" [value]="option">
                  {{option}}
                </mat-option>
              </mat-autocomplete>
            </div>
          </div>
          <!-- <hr> -->
        </div>
      </mat-expansion-panel>
    </mat-accordion>
    <mat-accordion id="OverallDetails">
      <mat-expansion-panel [expanded]="false" class="ia-expansion-panel pl-2">
        <mat-expansion-panel-header class="ia-mat-panel">
          <mat-panel-title>
            <span class="text-header inc-f">
              Overall Details
            </span>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div *ngIf="checkRoutePermission('Overall Detail')">
          <!-- <div class="row">
            <div class="col-lg-12 text-header inc-f">
              <i class="fa fa-list"></i> Overall Details
            </div>
          </div> -->

          <div class="row ml-2 mt-1">
            <div class="col-lg-3 mr-3">
              <label class="control-label fw">Overall Status</label>
              <input type="text" placeholder="Pick one" aria-label="Number" name="OverallStatus" matInput
                [matAutocomplete]="autoOS" class="form-control form-control-sm border-bottom"
                [(ngModel)]="selfAssessment.overallStatus" />
              <mat-autocomplete autoActiveFirstOption #autoOS="matAutocomplete"
                (optionSelected)="updateSectionLastEdited('OverallStatus')">
                <mat-option *ngFor="let option of overallStatus" [value]="option">
                  {{option}}
                </mat-option>
              </mat-autocomplete>
            </div>
            <div class="col-lg-3">
              <label class="control-label fw">Rule Conclusion</label>
              <input type="text" placeholder="Pick one" aria-label="Number" name="ruleConcusion" matInput
                [matAutocomplete]="autoRC" class="form-control form-control-sm border-bottom"
                [(ngModel)]="selfAssessment.ruleConclusion" />
              <mat-autocomplete autoActiveFirstOption #autoRC="matAutocomplete"
                (optionSelected)="updateSectionLastEdited('OverallStatus')">
                <mat-option *ngFor="let option of ruleConclusion" [value]="option">
                  {{option}}
                </mat-option>
              </mat-autocomplete>
            </div>
          </div>

          <div class="row ml-2 mt-1">
            <div class="col-lg-12">
              <div class="box-shadow p-2">
                <div class="header-text">
                  <span class="fa fa-chevron-down cursor-pointer" *ngIf="filterType === 'self' && !isSADetails3"
                    (click)="isSADetails3 = true"></span>
                  <span class="fa fa-chevron-up cursor-pointer" *ngIf="filterType === 'self' && isSADetails3"
                    (click)="isSADetails3 = false"></span>
                  <span class="control-label fw">
                    Overall Conclusion <span *ngIf="filterType !== 'self' && changeFields.includes('OverallConclusion')"
                      class="marking-changed-fields">Version {{versionNo}} </span>
                  </span>
                </div>
                <div *ngIf="filterType === 'self' && saDetailHistory && saDetailHistory.overallConclusion.length > 0">
                  <div *ngFor="let detailItem of saDetailHistory.overallConclusion">
                    <div class="pt-3" *ngIf="detailItem.itemTitle">
                      <div class="f-16 ck-content" [innerHTML]="sanitizeHtml(detailItem.itemTitle)"></div>
                    </div>
                  </div>
                </div>
                <div *ngIf="filterType === 'version'">
                  <div class="f-16 mt-1 ck-content" [innerHTML]="sanitizeHtml(selfAssessment.overallConclusion)"></div>
                </div>
                <div class="text-area-css overflow-auto disabled-div ck-content"
                  *ngIf="filterType === 'self' && saDetailHistory && saDetailHistory.overallConclusion.length === 0"
                  [innerHTML]="sanitizeHtml(selfAssessment.overallConclusion)"></div>
                  <app-ck-editor [(childVariable)]="selfAssessment.overallConclusion" [data]="selfAssessment.overallConclusion" id="overallConclusion" *ngIf="filterType === 'self' && isSADetails3" (keyUpEvent)="updateSectionLastEdited('OverallStatus')"></app-ck-editor>
                <!-- <ckeditor id="overallConclusion" [editor]="Editor" [(ngModel)]="selfAssessment.overallConclusion"
                  *ngIf="filterType === 'self' && isSADetails3" (keyup)="updateSectionLastEdited('OverallStatus')">
                </ckeditor> -->
              </div>
            </div>
          </div>
          <!-- <hr> -->
        </div>
      </mat-expansion-panel>
    </mat-accordion>
    <mat-accordion id="GapDetails">
      <mat-expansion-panel [expanded]="false" class="ia-expansion-panel pl-2">
        <mat-expansion-panel-header class="ia-mat-panel">
          <mat-panel-title>
            <span class="text-header inc-f">
              Gap Details
            </span>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div *ngIf="checkRoutePermission('Gap Detail')">
          <!-- <div class="row">
            <div class="col-lg-12 text-header inc-f">
              <i class="fa fa-list"></i> Gap Details
            </div>
          </div> -->

          <div class="row ml-2 mt-1">
            <div class="col-lg-12">
              <div class="box-shadow p-2">
                <div class="header-text">
                  <span class="fa fa-chevron-down cursor-pointer" *ngIf="filterType === 'self' && !isSADetails4"
                    (click)="isSADetails4 = true"></span>
                  <span class="fa fa-chevron-up cursor-pointer" *ngIf="filterType === 'self' && isSADetails4"
                    (click)="isSADetails4 = false"></span>
                  <span class="control-label fw">
                    Gap Description <span *ngIf="filterType !== 'self' && changeFields.includes('GapDescription')"
                      class="marking-changed-fields">Version {{versionNo}} </span>
                  </span>
                </div>
                <div *ngIf="filterType === 'self' && saDetailHistory && saDetailHistory.gapDescription.length > 0">
                  <div *ngFor="let detailItem of saDetailHistory.gapDescription">
                    <div class="pt-3" *ngIf="detailItem.itemTitle">
                      <div class="f-16 ck-content" [innerHTML]="sanitizeHtml(detailItem.itemTitle)"></div>
                    </div>
                  </div>
                </div>
                <div *ngIf="filterType === 'version'">
                  <div class="f-16 mt-1 ck-content" [innerHTML]="sanitizeHtml(selfAssessment.gapDescription)"></div>
                </div>
                <div class="text-area-css overflow-auto disabled-div ck-content"
                  *ngIf="filterType === 'self' && saDetailHistory && saDetailHistory.gapDescription.length === 0"
                  [innerHTML]="sanitizeHtml(selfAssessment.gapDescription)"></div>
                  <app-ck-editor [(childVariable)]="selfAssessment.gapDescription" [data]="selfAssessment.gapDescription" id="gapDescription" *ngIf="filterType === 'self' && isSADetails4" (keyUpEvent)="updateSectionLastEdited('Gap')"></app-ck-editor>
                <!-- <ckeditor id="gapDescription" [editor]="Editor" [(ngModel)]="selfAssessment.gapDescription"
                  *ngIf="filterType === 'self' && isSADetails4" (keyup)="updateSectionLastEdited('Gap')"></ckeditor> -->
              </div>
            </div>
          </div>

          <div class="row ml-2 my-4">
            <div class="col-lg-4">
              <label class="control-label fw">Gap Review Status</label>
              <input type="text" placeholder="Pick one" aria-label="Number" name="rule applicable" matInput
                [(ngModel)]="selfAssessment.gapReviewStatus" [matAutocomplete]="autoGRS"
                class="form-control form-control-sm border-bottom" />
              <mat-autocomplete autoActiveFirstOption #autoGRS="matAutocomplete"
                (optionSelected)="updateSectionLastEdited('Gap')">
                <mat-option *ngFor="let option of gapReviewStatus" [value]="option">
                  {{option}}
                </mat-option>
              </mat-autocomplete>
            </div>
            <div class="col-lg-4">
              <label class="control-label fw">Gap Action Team</label>
              <input type="text" [(ngModel)]="selfAssessment.actionTeam" (keyup)="updateSectionLastEdited('Gap')"
                class="form-control form-control-sm" />
            </div>
            <div class="col-lg-4">
              <label class="control-label fw">Gap Action Owner</label>
              <mat-chip-grid #actOwnerList>
                <mat-chip-row *ngFor="let actOwner of actOwnerDD" [selectable]="selectable"
                  [removable]="removable && !isVersioned" (removed)="removeActionOwner(actOwner)">
                  {{actOwner}}
                  <mat-icon matChipRemove *ngIf="removable && !isVersioned">x</mat-icon>
                </mat-chip-row>
                <input class="form-control form-control-sm h-33 mat-autodd-input border-bottom" #actOwnerInput
                  [formControl]="searchActOwnerCntrl" [matAutocomplete]="actOwnerAutocomplete"
                  [matChipInputFor]="actOwnerList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                  [matChipInputAddOnBlur]="addOnBlur" autocomplete="off"
                  (matChipInputTokenEnd)="addActionOwner($event)">
              </mat-chip-grid>
              <mat-autocomplete #actOwnerAutocomplete="matAutocomplete"
                (optionSelected)="selectedActionOwnerEvent($event)">
                <mat-option *ngFor="let actOwner of searchedActOwner" [value]="actOwner.value">
                  {{actOwner.name}}
                </mat-option>
              </mat-autocomplete>
            </div>
          </div>

          <div class="row ml-2 mt-1">
            <div class="col-lg-12">
              <div class="box-shadow p-2">
                <div class="header-text">
                  <span class="fa fa-chevron-down cursor-pointer" *ngIf="filterType === 'self' && !isSADetails5"
                    (click)="isSADetails5 = true"></span>
                  <span class="fa fa-chevron-up cursor-pointer" *ngIf="filterType === 'self' && isSADetails5"
                    (click)="isSADetails5 = false"></span>
                  <span class="control-label fw">
                    Gap Remediation Action <span
                      *ngIf="filterType !== 'self' && changeFields.includes('RemediationAction')"
                      class="marking-changed-fields">Version {{versionNo}} </span>
                  </span>
                </div>
                <div *ngIf="filterType === 'self' && saDetailHistory && saDetailHistory.remediationAction.length > 0">
                  <div *ngFor="let detailItem of saDetailHistory.remediationAction">
                    <div class="pt-3" *ngIf="detailItem.itemTitle">
                      <div class="f-16 ck-content" [innerHTML]="sanitizeHtml(detailItem.itemTitle)"></div>
                    </div>
                  </div>
                </div>
                <div *ngIf="filterType === 'version'">
                  <div class="f-16 mt-1 ck-content" [innerHTML]="sanitizeHtml(selfAssessment.remediationAction)"></div>
                </div>
                <div class="text-area-css overflow-auto disabled-div ck-content"
                  *ngIf="filterType === 'self' && saDetailHistory && saDetailHistory.remediationAction.length === 0"
                  [innerHTML]="sanitizeHtml(selfAssessment.remediationAction)"></div>
                  <app-ck-editor [(childVariable)]="selfAssessment.remediationAction" [data]="selfAssessment.remediationAction" id="remediationAction" *ngIf="filterType === 'self' && isSADetails5" (keyUpEvent)="updateSectionLastEdited('Gap')"></app-ck-editor>
                <!-- <ckeditor id="remediationAction" *ngIf="filterType === 'self' && isSADetails5" [editor]="Editor"
                  [(ngModel)]="selfAssessment.remediationAction" (keyup)="updateSectionLastEdited('Gap')"></ckeditor> -->
              </div>
            </div>
          </div>

          <div class="row ml-2 my-4">
            <div class="col-lg-4">
              <label class="control-label fw">Gap Action Last Edited</label>
              <div class="input-group input-group-sm">
                <input matInput [matDatepicker]="actionLastEdited" (click)="actionLastEdited.open()" disabled
                  class="form-control form-control-sm border-bottom" [(ngModel)]="selfAssessment.actionLastEdited"
                  name="ActionLastEdited" (dateInput)="updateSectionLastEdited('Gap')" />
                <div class="input-group-append">
                  <span class="input-group-text fa fa-calendar" disabled (click)="actionLastEdited.open()"></span>
                </div>
              </div>
              <mat-datepicker #actionLastEdited></mat-datepicker>
            </div>
            <div class="col-lg-4">
              <label class="control-label fw">Gap Action Due Date</label>
              <div class="input-group input-group-sm">
                <input matInput [matDatepicker]="actionDueDate" (click)="actionDueDate.open()"
                  class="form-control form-control-sm border-bottom" [(ngModel)]="selfAssessment.actionDueDate"
                  name="ActionDueDate" (dateInput)="updateSectionLastEdited('Gap')" />
                <div class="input-group-append">
                  <span class="input-group-text fa fa-calendar" (click)="actionDueDate.open()"></span>
                </div>
              </div>
              <mat-datepicker #actionDueDate (selectedChanged)="updateSectionLastEdited('Gap')"></mat-datepicker>
            </div>
            <div class="col-lg-4">
              <label class="control-label fw">Gap Action Status</label>
              <input type="text" placeholder="Pick one" aria-label="Number" name="actionStatus" matInput
                [matAutocomplete]="autoACS" class="form-control form-control-sm border-bottom"
                [(ngModel)]="selfAssessment.actionStatus" />
              <mat-autocomplete autoActiveFirstOption #autoACS="matAutocomplete"
                (optionSelected)="updateSectionLastEdited('Gap')">
                <mat-option *ngFor="let option of actionStatus" [value]="option">
                  {{option}}
                </mat-option>
              </mat-autocomplete>
            </div>
          </div>

          <div class="row ml-2 mt-1">
            <div class="col-lg-12">
              <div class="box-shadow p-2">
                <div class="header-text">
                  <span class="fa fa-chevron-down cursor-pointer" *ngIf="filterType === 'self' && !isSADetails6"
                    (click)="isSADetails6 = true"></span>
                  <span class="fa fa-chevron-up cursor-pointer" *ngIf="filterType === 'self' && isSADetails6"
                    (click)="isSADetails6 = false"></span>
                  <span class="control-label fw">
                    Gap Closure Rationale <span
                      *ngIf="filterType !== 'self' && changeFields.includes('ClosureRationale')"
                      class="marking-changed-fields">Version {{versionNo}} </span>
                  </span>
                </div>
                <div *ngIf="filterType === 'self' && saDetailHistory && saDetailHistory.closureRationale.length > 0">
                  <div *ngFor="let detailItem of saDetailHistory.closureRationale">
                    <div class="pt-3" *ngIf="detailItem.itemTitle">
                      <div class="f-16 ck-content" [innerHTML]="sanitizeHtml(detailItem.itemTitle)"></div>
                    </div>
                  </div>
                </div>
                <div *ngIf="filterType === 'version'">
                  <div class="f-16 mt-1 ck-content" [innerHTML]="sanitizeHtml(selfAssessment.closureRationale)"></div>
                </div>
                <div class="text-area-css overflow-auto disabled-div ck-content"
                  *ngIf="filterType === 'self' && saDetailHistory && saDetailHistory.closureRationale.length === 0"
                  [innerHTML]="sanitizeHtml(selfAssessment.closureRationale)"></div>
                  <app-ck-editor [(childVariable)]="selfAssessment.closureRationale" [data]="selfAssessment.closureRationale" id="closureRationale" *ngIf="filterType === 'self' && isSADetails6" (keyUpEvent)="updateSectionLastEdited('Gap')"></app-ck-editor>
                <!-- <ckeditor id="closureRationale" *ngIf="filterType === 'self' && isSADetails6" [editor]="Editor"
                  [(ngModel)]="selfAssessment.closureRationale" (keyup)="updateSectionLastEdited('Gap')"></ckeditor> -->
              </div>
            </div>
          </div>
        </div>
      </mat-expansion-panel>
    </mat-accordion>
    <mat-accordion id="EnhancementDetails">
      <mat-expansion-panel [expanded]="false" class="ia-expansion-panel pl-2">
        <mat-expansion-panel-header class="ia-mat-panel">
          <mat-panel-title>
            <span class="text-header inc-f">
              Enhancement Details
            </span>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div id="EnhancementDetails" *ngIf="checkRoutePermission('Enhancement Detail')">
          <!-- <div class="row">
            <div class="col-lg-12 text-header inc-f">
              <i class="fa fa-list"></i> Enhancement Details
            </div>
          </div> -->

          <div class="row ml-2 mt-1">
            <div class="col-lg-12">
              <div class="box-shadow p-2">
                <div class="header-text">
                  <span class="fa fa-chevron-down cursor-pointer" *ngIf="filterType === 'self' && !isSADetails7"
                    (click)="isSADetails7 = true"></span>
                  <span class="fa fa-chevron-up cursor-pointer" *ngIf="filterType === 'self' && isSADetails7"
                    (click)="isSADetails7 = false"></span>
                  <span class="control-label fw">
                    Enhancement Description <span
                      *ngIf="filterType !== 'self' && changeFields.includes('EnhancementDescription')"
                      class="marking-changed-fields">Version {{versionNo}} </span>
                  </span>
                </div>
                <div
                  *ngIf="filterType === 'self' && saDetailHistory && saDetailHistory.enhancementDescription.length > 0">
                  <div *ngFor="let detailItem of saDetailHistory.enhancementDescription">
                    <div class="pt-3" *ngIf="detailItem.itemTitle">
                      <div class="f-16 ck-content" [innerHTML]="sanitizeHtml(detailItem.itemTitle)"></div>
                    </div>
                  </div>
                </div>
                <div *ngIf="filterType === 'version'">
                  <div class="f-16 mt-1 ck-content" [innerHTML]="sanitizeHtml(selfAssessment.enhancementDescription)"></div>
                </div>
                <div class="text-area-css overflow-auto disabled-div ck-content"
                  *ngIf="filterType === 'self' && saDetailHistory && saDetailHistory.enhancementDescription.length === 0"
                  [innerHTML]="sanitizeHtml(selfAssessment.enhancementDescription)"></div>
                  <app-ck-editor [(childVariable)]="selfAssessment.enhancementDescription" [data]="selfAssessment.enhancementDescription" id="enhancementDescription" *ngIf="filterType === 'self' && isSADetails7" (keyUpEvent)="updateSectionLastEdited('Enhancement')"></app-ck-editor>
                <!-- <ckeditor id="enhancementDescription" *ngIf="filterType === 'self' && isSADetails7" [editor]="Editor"
                  [(ngModel)]="selfAssessment.enhancementDescription" (keyup)="updateSectionLastEdited('Enhancement')">
                </ckeditor> -->
              </div>
            </div>
          </div>

          <div class="row ml-2 my-5">
            <div class="col-lg-4">
              <label class="control-label fw">Enhancement Review Status</label>
              <input type="text" placeholder="Pick one" aria-label="Number" name="Enhancement review status" matInput
                [(ngModel)]="selfAssessment.enhancementReviewStatus" [matAutocomplete]="autoERS"
                class="form-control form-control-sm border-bottom" />
              <mat-autocomplete autoActiveFirstOption #autoERS="matAutocomplete"
                (optionSelected)="updateSectionLastEdited('Enhancement')">
                <mat-option *ngFor="let option of enhancementReviewStatus" [value]="option">
                  {{option}}
                </mat-option>
              </mat-autocomplete>
            </div>
            <div class="col-lg-4">
              <label class="control-label fw">Enhancement Action Team</label>
              <input type="text" [(ngModel)]="selfAssessment.enhancementActionTeam"
                (keyup)="updateSectionLastEdited('Enhancement')" class="form-control form-control-sm" />
            </div>
            <div class="col-lg-4">
              <label class="control-label fw">Enhancement Action Owner </label>
              <mat-chip-grid #enhmtActOwnerList>
                <mat-chip-row *ngFor="let enhmtActOwner of enhmtActOwnerDD" [selectable]="selectable"
                  [removable]="removable && !isVersioned" (removed)="removeEnhmtActionOwner(enhmtActOwner)">
                  {{enhmtActOwner}}
                  <mat-icon matChipRemove *ngIf="removable && !isVersioned">x</mat-icon>
                </mat-chip-row>
                <input class="form-control form-control-sm h-33 mat-autodd-input border-bottom" #enhmtActOwnerInput
                  [formControl]="searchEnhmtActOwnerCntrl" [matAutocomplete]="enhmtActOwnerAutocomplete"
                  [matChipInputFor]="enhmtActOwnerList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                  [matChipInputAddOnBlur]="addOnBlur" autocomplete="off"
                  (matChipInputTokenEnd)="addEnhmtActionOwner($event)">
              </mat-chip-grid>
              <mat-autocomplete #enhmtActOwnerAutocomplete="matAutocomplete"
                (optionSelected)="selectedEnhmtActionOwnerEvent($event)">
                <mat-option *ngFor="let enhmtActOwner of searchedEnhmtActOwner" [value]="enhmtActOwner.value">
                  {{enhmtActOwner.name}}
                </mat-option>
              </mat-autocomplete>
            </div>
          </div>

          <div class="row ml-2 mt-1">
            <div class="col-lg-12">
              <div class="box-shadow p-2">
                <div class="header-text">
                  <span class="fa fa-chevron-down cursor-pointer" *ngIf="filterType === 'self' && !isSADetails8"
                    (click)="isSADetails8 = true"></span>
                  <span class="fa fa-chevron-up cursor-pointer" *ngIf="filterType === 'self' && isSADetails8"
                    (click)="isSADetails8 = false"></span>
                  <span class="control-label fw">
                    Enhancement Action <span *ngIf="filterType !== 'self' && changeFields.includes('EnhancementAction')"
                      class="marking-changed-fields">Version {{versionNo}} </span>
                  </span>
                </div>
                <div *ngIf="filterType === 'self' && saDetailHistory && saDetailHistory.enhancementAction.length > 0">
                  <div *ngFor="let detailItem of saDetailHistory.enhancementAction">
                    <div class="pt-3" *ngIf="detailItem.itemTitle">
                      <div class="f-16 ck-content" [innerHTML]="sanitizeHtml(detailItem.itemTitle)"></div>
                    </div>
                  </div>
                </div>
                <div *ngIf="filterType === 'version'">
                  <div class="f-16 mt-1 ck-content" [innerHTML]="sanitizeHtml(selfAssessment.enhancementAction)"></div>
                </div>
                <div class="text-area-css overflow-auto disabled-div ck-content"
                  *ngIf="filterType === 'self' && saDetailHistory && saDetailHistory.enhancementAction.length === 0"
                  [innerHTML]="sanitizeHtml(selfAssessment.enhancementAction)"></div>
                  <app-ck-editor [(childVariable)]="selfAssessment.enhancementAction" [data]="selfAssessment.enhancementAction" id="enhancementAction" *ngIf="filterType === 'self' && isSADetails8" (keyUpEvent)="updateSectionLastEdited('Enhancement')"></app-ck-editor>
                <!-- <ckeditor id="enhancementAction" *ngIf="filterType === 'self' && isSADetails8" [editor]="Editor"
                  [(ngModel)]="selfAssessment.enhancementAction" (keyup)="updateSectionLastEdited('Enhancement')">
                </ckeditor> -->
              </div>
            </div>
          </div>

          <div class="row ml-2 mt-5">
            <div class="col-lg-4">
              <label class="control-label fw">Enhancement Action Last Edited</label>
              <div class="input-group input-group-sm">
                <input matInput [matDatepicker]="enhancementLastEdited" (click)="enhancementLastEdited.open()"
                  class="form-control form-control-sm border-bottom" disabled
                  (dateInput)="updateSectionLastEdited('Enhancement')"
                  [(ngModel)]="selfAssessment.enhancementActionLastEdited" name="enhancementLastEdited" />
                <div class="input-group-append">
                  <span class="input-group-text fa fa-calendar" disabled (click)="enhancementLastEdited.open()"></span>
                </div>
              </div>
              <mat-datepicker #enhancementLastEdited></mat-datepicker>
            </div>
            <div class="col-lg-4">
              <label class="control-label fw">Enhancement Action Due Date</label>
              <div class="input-group input-group-sm">
                <input matInput [matDatepicker]="enhancementDueDate" (click)="enhancementDueDate.open()"
                  class="form-control form-control-sm border-bottom"
                  [(ngModel)]="selfAssessment.enhancementActionDueDate" name="EnhancementDueDate"
                  (dateInput)="updateSectionLastEdited('Enhancement')" />
                <div class="input-group-append">
                  <span class="input-group-text fa fa-calendar" (click)="enhancementDueDate.open()"></span>
                </div>
              </div>
              <mat-datepicker #enhancementDueDate (selectedChanged)="updateSectionLastEdited('Enhancement')">
              </mat-datepicker>
            </div>
            <div class="col-lg-4">
              <label class="control-label fw">Enhancement Action Status</label>
              <input type="text" placeholder="Pick one" aria-label="Number" name="enhancementActionStatus" matInput
                [matAutocomplete]="autoEACS" class="form-control form-control-sm border-bottom"
                [(ngModel)]="selfAssessment.enhancementActionStatus" />
              <mat-autocomplete autoActiveFirstOption #autoEACS="matAutocomplete"
                (optionSelected)="updateSectionLastEdited('Enhancement')">
                <mat-option *ngFor="let option of enhancementActionStatus" [value]="option">
                  {{option}}
                </mat-option>
              </mat-autocomplete>
            </div>
          </div>
        </div>
      </mat-expansion-panel>
    </mat-accordion>
  </div>
</div>
</div>
<!-- <div *ngIf="templateNo==2">
  <app-self-assessment-t2-details></app-self-assessment-t2-details>
</div> -->